// Approved, authenticated portrait responses may carry two generated scene variants.
// Keep the whole figure, pedestal and floor reflection together; never crop/refit it.
export function selectPortraitScene(source, scene) {
 const asset=source?.scene_variants?.[scene];
 if (!['home','career'].includes(scene) || !asset || asset.has_podium!==true ||
     typeof asset.data_url!=='string' || !asset.data_url.startsWith('data:image/webp;base64,')) return source;
 return {...source,...asset,data_url:asset.data_url,desktop_data_url:null,mobile_data_url:null,
   placement:null,has_podium:true,seated:false,scene_key:scene};
}
